import React, { PureComponent, useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import Page from '../../components/Page';
// import { useNavigate } from 'react-router-dom';
//Material
// import ReplyIcon from '@mui/icons-material/Reply';
import { Autocomplete, Avatar, Box, Grid, Stack, TextField, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import BoosterPng from '../../assets/Booster.png';
import DefaultAvatar from '../../assets/defaultPostImg.jpg';
import { LetsGoBtn } from '../../components/Buttons';
import { StyledTitle } from '../../components/StyledComponents';
import TariffCard from '../../components/TariffCard';
import ApiService from '../../helpers/apiHelper';
import { monthHandler } from '../../helpers/date-helpers';
import {
  setIsOpenAccountPromoteModal,
  setIsOpenBoostersModal,
  setIsOpenFreezePremiumModal
} from '../../redux/mainReducer';
import '../MainPage/index.css';
import BuyersTable from './Tables/BuyersTable';
import ServicesTable from './Tables/ServicesTable';
import Slider from 'react-slick';
import './index.css';
import PromotionTable from './Tables/Promotion';
import styled from '@emotion/styled';

// import { Spinner } from '../../components/Spinner';

class CustomizedAxisTick extends PureComponent {
  render() {
    const { x, y, payload } = this.props;

    return (
      <g transform={`translate(${x},${y})`}>
        <text x={0} y={0} dy={12} textAnchor="end" fill="#C8C8C8">
          {payload.value}
        </text>
      </g>
    );
  }
}

const CssTextField = styled(TextField)(({ theme }) => ({
  '& label.Mui-focused': {
    color: '#000000'
  },
  '& label': {
    color: '#7C7C7C',
    opacity: 1,
    fontFamily: 'FixelText-Regular'
  },
  '& .MuiInputBase-root': {
    alignItems: 'end',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
    borderRadius: '8px',
    fontSize: '16px', // default
    [theme.breakpoints.up('xs')]: {
      fontSize: '14px'
    }
  },

  '& .MuiOutlinedInput-input': {
    fontSize: { xs: '14px', sm: '16px' }, // ← вот сюда
    fontFamily: 'FixelText-Medium !important',
    padding: '7px !important',
    [theme.breakpoints.up('xs')]: {
      padding: '2px !important'
    },
    [theme.breakpoints.up('sm')]: {
      padding: '7px !important'
    }
  },
  margin: '5px 0px',

  '& ::placeholder': {
    color: '#7C7C7C',
    opacity: 1
  },

  '& .MuiInputBase-root.Mui-error': {
    backgroundColor: '#FFE5E5 !important'
  }
}));

function TariffPage(props) {
  const [sortType, setSortType] = useState('Товарів продано за період');
  const [period, setPeriod] = useState('Місяць');
  const [year, setYear] = useState(new Date().getFullYear());
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [graphData, setGraphData] = useState([]);
  const [analytics, setAnalytics] = useState(null);
  // eslint-disable-next-line
  // const [day, setDay] = useState(new Date().toISOString());
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const innerWidth = window.innerWidth;

  const analyticsApi = new ApiService('auth/premium-page/get-user-analytics');
  const dataHandler = (type, graphData) => {
    const typeHandler = (period = 'Місяць') => {
      if (period === 'Місяць') {
        switch (type) {
          case 'Товарів продано за період':
            return 'servicePoint';
          case 'Коштів отримано за період':
            return 'incomesPoint';
          case 'Нових підписників за період':
            return 'subscriptionPoint';
          default:
            return;
        }
      } else {
        switch (type) {
          case 'Товарів продано за період':
            return 'serviceSales';
          case 'Коштів отримано за період':
            return 'incomes';
          case 'Нових підписників за період':
            return 'subscriptionNumber';
          default:
            return;
        }
      }
    };

    const preparedGraphData = [];
    if (month !== 0) {
      const daysInMonth = dayjs(`${year}-${month}-01`).daysInMonth();

      for (let count = 1; count <= daysInMonth; count++) {
        const dayData = graphData.filter(
          (data) => dayjs(new Date(data.creationDate)).date() === count
        );

        if (dayData.length === 0) {
          preparedGraphData.push({
            name: `${count}`,
            uv: 0
          });
        } else {
          dayData.forEach((data) => {
            preparedGraphData.push({
              name: `${count}`,
              uv: +data[typeHandler()]
            });
          });
        }
      }
    } else {
      for (let count = 1; count <= 12; count++) {
        const monthData = graphData.filter(
          (data) => dayjs(data.creationDate).month() + 1 === count
        );

        if (monthData.length === 0) {
          preparedGraphData.push({
            name: `${monthHandler(count, 'year')}`,
            uv: 0
          });
        } else {
          monthData.forEach((data) => {
            preparedGraphData.push({
              name: `${monthHandler(count, 'year')}`,
              uv: +data[typeHandler('year')]
            });
          });
        }
      }
    }
    setGraphData(preparedGraphData);
  };
  const carouselSettings = {
    autoplay: true,
    autoplaySpeed: 5000,
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 3,
    slidesToScroll: 1,
    useCSS: true,
    arrows: true

    // beforeChange: (current, next) => setActiveSlide(next)a
  };
  let carouselSlides = [
    <TariffCard
      index="0"
      type="base"
      active={!props?.premiumSubscription?.subscriptionType}
      userSubscription={props?.premiumSubscription}
    />,

    <TariffCard
      index="1"
      type="MONTH_PREMIUM"
      userSubscription={props?.premiumSubscription}
      active={props?.premiumSubscription?.subscriptionType === 'MONTH_PREMIUM'}
    />,

    <TariffCard
      index="2"
      type="THREE_MONTH_PREMIUM"
      userSubscription={props?.premiumSubscription}
      active={props?.premiumSubscription?.subscriptionType === 'THREE_MONTH_PREMIUM'}
    />,

    <TariffCard
      index="3"
      type="YEAR_PREMIUM"
      userSubscription={props?.premiumSubscription}
      active={props?.premiumSubscription?.subscriptionType === 'YEAR_PREMIUM'}
    />
  ];

  useEffect(() => {
    if (
      props?.userData &&
      Object.keys(props?.userData).length !== 0 &&
      props?.userData?.role !== 'PREMIUM_USER' &&
      props?.userData?.role !== 'USER' &&
      props?.userData?.role !== 'FREEZE_PREMIUM'
    ) {
      navigate('/ua');
    } else {
    }
    if (
      props?.userData &&
      Object.keys(props?.userData).length !== 0 &&
      props?.userData?.role === 'FREEZE_PREMIUM'
    ) {
      dispatch(setIsOpenFreezePremiumModal(true));
    }
    // eslint-disable-next-line
  }, [props?.userData]);

  useEffect(() => {
    if (props?.userData && props?.userData?.role === 'PREMIUM_USER') {
      analyticsApi
        .getAll({ year: +year, month: +month })
        .then((res) => {
          setAnalytics(res?.result);
          if (res?.result?.graphs) {
            dataHandler(sortType, res?.result?.graphs);
          } else {
            dataHandler(sortType, res?.result?.yearAnalytics);
          }
        })
        .catch((error) => {
          console.error();
          dataHandler(sortType, []);
        });
    }
    // eslint-disable-next-line
  }, [props?.userData, sortType, year, month, period]);

  return (
    <Page
      title="Тарифи"
      description="Тарифи на преміум підписки сайту BONFAIR"
      isIndex={true}
      canonical={window.location.origin + window.location.pathname}
      sx={{
        display: 'flex',
        marginTop: '90px',
        alignItems: 'center',
        flexDirection: 'column',
        height: 'max-content',
        padding: { xs: '0px 20px 50px', sm: '0px 20px 80px', md: '0px 50px', lg: '0px 100px' }
      }}
    >
      <Grid
        container
        style={{
          maxWidth: '1440px',
          paddingTop: '65px'
        }}
        spacing={{ xs: 0, sm: 0, md: 3 }}
      >
        <Grid item xs={12}>
          <StyledTitle
            variant="h1"
            className="bottomBlock-title"
            style={{ marginBottom: '50px' }}
            // sx={{
            //   textTransform: 'none',
            //   fontSize: '32px !important',
            //   fontFamily: 'FixelText-Regular !important'
            // }}
          >
            {props?.userData && props?.userData?.role !== 'PREMIUM_USER'
              ? 'Тарифні плани'
              : 'Керування Преміум-акаунтом'}
          </StyledTitle>
        </Grid>
        {props?.userData && props?.userData?.role === 'PREMIUM_USER' && (
          <>
            <Grid item xs={12}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={6}>
                  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography
                      variant="p"
                      sx={{
                        margin: '0px 0px 20px',
                        wordBreak: 'break-word',
                        fontFamily: 'FixelText-Medium !important',
                        fontSize: { xs: '20px', sm: '24px' },
                        textAlign: 'left',
                        fontWeight: 500
                      }}
                    >
                      Профіль
                    </Typography>
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: { xs: '8px', md: '20px' },
                        borderRadius: '8px',
                        boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                        backgroundColor: 'white',
                        flexWrap: { xs: 'wrap', sm: 'nowrap' }
                      }}
                    >
                      <Stack
                        sx={{
                          width: '100%',
                          marginLeft: '0px',
                          flexDirection: 'row',
                          alignItems: 'center'
                        }}
                      >
                        <Avatar
                          onClick={() => {
                            navigate(`/ua/user-page/${props?.userData?.id}?type=posts`);
                          }}
                          src={
                            props?.userData?.photoUrl ? props?.userData?.photoUrl : DefaultAvatar
                          }
                          sx={{
                            width: { xs: 60, sm: 80 },
                            height: { xs: 60, sm: 80 },
                            border: '2px solid #E2F2FF',
                            cursor: 'pointer',
                            boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)'
                          }}
                        />
                        <Box
                          sx={{
                            width: '100%',
                            marginLeft: '16px',
                            display: 'flex',
                            flexDirection: 'column'
                          }}
                        >
                          <Typography
                            variant="subtitle"
                            sx={{
                              fontFamily: 'FixelText-Medium !important',
                              fontWeight: 500,
                              fontSize: { xs: '14px', sm: '16px' },
                              textAlign: 'left',
                              cursor: 'pointer',
                              color: '#7C7C7C'
                            }}
                            onClick={() => {
                              navigate(`/ua/user-page/${props?.userData.id}?type=posts`);
                            }}
                          >
                            {`@${props?.userData?.nickname}`}
                          </Typography>
                          {props?.userData?.name && props?.userData?.surname && (
                            <Typography
                              variant="subtitle"
                              sx={{
                                fontFamily: 'FixelText-Medium !important',
                                fontWeight: 500,
                                fontSize: { xs: '16px', sm: '20px' },
                                textAlign: 'left',
                                cursor: 'pointer',
                                textWrap: 'wrap',
                                wordBreak: 'break-word'
                              }}
                              onClick={() => {
                                navigate(`/ua/user-page/${props?.userData.id}?type=posts`);
                              }}
                            >
                              {`${props?.userData?.name} ${props?.userData?.surname}`}
                            </Typography>
                          )}
                        </Box>
                      </Stack>
                      <Stack
                        sx={{
                          flexDirection: { xs: 'row', sm: 'column' },
                          width: '100%',
                          alignItems: { xs: 'center', sm: 'end' }
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: 'FixelText-Medium !important',
                            fontWeight: 500,
                            fontSize: { xs: '16px' },
                            textAlign: 'center',
                            cursor: 'pointer',
                            color: '#60A5DF',
                            mb: { xs: '0px', sm: '10px' }
                          }}
                          onClick={() => {
                            navigate(`/ua/account-settings`);
                          }}
                        >
                          Керування підпискою
                        </Typography>
                        <LetsGoBtn
                          colorScheme="blue"
                          width={{ xs: '130px', sm: '170px' }}
                          margin={{ xs: '0px 0px 0px auto', sm: '0px' }}
                          text="Просувати"
                          onClick={() => {
                            dispatch(setIsOpenAccountPromoteModal(true));
                          }}
                        />
                      </Stack>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography
                      variant="p"
                      sx={{
                        margin: '0px 0px 20px',
                        wordBreak: 'break-word',
                        fontFamily: 'FixelText-Medium !important',
                        fontSize: { xs: '20px', sm: '24px' },
                        textAlign: 'left',
                        fontWeight: 500
                      }}
                    >
                      Бустери
                    </Typography>
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: { xs: ' 24px 8px', md: '24px' },
                        borderRadius: '8px',
                        boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                        backgroundColor: 'white',
                        minHeight: { xs: '113px', sm: '120px' }
                      }}
                    >
                      <Typography
                        variant="p"
                        sx={{
                          margin: '0px 10px',
                          wordBreak: 'break-word',
                          fontFamily: 'FixelText-Medium !important',
                          fontWeight: 500,
                          fontSize: { xs: '20px', sm: '20px' },
                          textAlign: 'left',
                          alignItems: 'center',
                          display: 'flex'
                        }}
                      >
                        <img
                          width={42}
                          height={30}
                          src={BoosterPng}
                          alt="booster"
                          style={{ marginRight: '10px' }}
                        />
                        {`Баланс: ${props?.boosters}`}
                      </Typography>
                      <LetsGoBtn
                        colorScheme="white"
                        width={{ xs: '145px', sm: '230px' }}
                        margin="0px "
                        text="Поповнити баланс"
                        onClick={() => {
                          dispatch(setIsOpenBoostersModal(true));
                        }}
                      />
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={2} sx={{ justifyContent: 'center' }}>
                <Grid item xs={12}>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      width: '100%',
                      justifyContent: 'space-between',
                      alignItems: 'center'
                    }}
                  >
                    <Typography
                      variant="p"
                      sx={{
                        margin: '20px 0px 0px',
                        wordBreak: 'break-word',
                        fontFamily: 'FixelText-Medium !important',
                        fontSize: { xs: '20px', sm: '24px' },
                        textAlign: 'left',
                        fontWeight: 500
                      }}
                    >
                      Аналітика
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={6} sm={4}>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                      padding: { xs: '8px', sm: '16px', md: '24px' },
                      borderRadius: '8px',
                      backgroundColor: 'white'
                    }}
                  >
                    <Stack sx={{ width: '100%', marginLeft: '0px' }}>
                      <Typography
                        variant="subtitle"
                        sx={{
                          fontFamily: 'FixelText-Medium !important',
                          fontSize: { xs: '12px', sm: '18px', md: '24px' },
                          fontWeight: 500,
                          textAlign: 'left',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          mb: 1
                        }}
                      >
                        {`Продано товарів`}
                        {
                          <Typography
                            sx={{
                              fontSize: { xs: '12px', sm: '20px', md: '24px' },
                              color: '#7C7C7C'
                            }}
                          >
                            {period}
                          </Typography>
                        }
                      </Typography>

                      <Typography
                        variant="subtitle"
                        sx={{
                          fontFamily: 'FixelText-Medium !important',
                          fontSize: { xs: '12px', sm: '20px', md: '32px' },
                          fontWeight: 500,
                          textAlign: 'left',
                          cursor: 'pointer',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          lineHeight: '29px'
                        }}
                      >
                        {analytics ? analytics?.serviceSales : 0}
                        {
                          <>
                            {analytics?.serviceSalesPercent &&
                            analytics?.serviceSalesPercent.length !== 0 ? (
                              <>
                                {analytics?.serviceSalesPercent &&
                                analytics?.serviceSalesPercent.includes('-') ? (
                                  <>
                                    <Box
                                      sx={{
                                        borderRadius: '5px',
                                        backgroundColor: '#FFE4E1',
                                        color: '#F64D36',
                                        fontFamily: 'FixelText-Medium !important',
                                        fontWeight: 500,
                                        fontSize: {
                                          xs: '12px',
                                          sm: '16px',
                                          md: '20px'
                                        },
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: '2px 10px',
                                        maxHeight: '25px'
                                      }}
                                    >
                                      {/* <TrendingDownIcon
                                        sx={{ color: '#F64D36', fontSize: '14px', mr: 0.5 }}
                                      /> */}
                                      {`${analytics?.serviceSalesPercent}%`}
                                    </Box>
                                  </>
                                ) : (
                                  <>
                                    <Box
                                      sx={{
                                        borderRadius: '5px',
                                        backgroundColor: '#DDF8DB',
                                        color: '#67C062',
                                        fontFamily: 'FixelText-Medium !important',
                                        fontWeight: 500,
                                        fontSize: {
                                          xs: '12px',
                                          sm: '16px',
                                          md: '20px'
                                        },
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: '2px 10px',
                                        maxHeight: '25px'
                                      }}
                                    >
                                      {' '}
                                      {/* <TrendingUpIcon
                                        sx={{ color: '#67C062', fontSize: '14px', mr: 0.5 }}
                                      /> */}
                                      +{`${analytics?.serviceSalesPercent}%`}
                                    </Box>
                                  </>
                                )}
                              </>
                            ) : null}
                          </>
                        }
                      </Typography>
                    </Stack>
                  </Box>
                </Grid>
                <Grid item xs={6} sm={4}>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                      padding: { xs: '8px', sm: '16px', md: '24px' },
                      borderRadius: '8px',
                      backgroundColor: 'white'
                    }}
                  >
                    <Stack sx={{ width: '100%', marginLeft: '0px' }}>
                      <Typography
                        variant="subtitle"
                        sx={{
                          fontFamily: 'FixelText-Medium !important',
                          fontSize: { xs: '12px', sm: '18px', md: '24px' },
                          fontWeight: 500,
                          textAlign: 'left',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          mb: 1
                        }}
                      >
                        {`Дохід, грн`}
                        {
                          <Typography
                            sx={{
                              fontSize: { xs: '12px', sm: '20px', md: '24px' },
                              color: '#7C7C7C'
                            }}
                          >
                            {period}
                          </Typography>
                        }
                      </Typography>

                      <Typography
                        variant="subtitle"
                        sx={{
                          fontFamily: 'FixelText-Medium !important',
                          fontSize: { xs: '12px', sm: '20px', md: '32px' },
                          fontWeight: 500,
                          textAlign: 'left',
                          cursor: 'pointer',
                          // color: '#60A5DF',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          lineHeight: '29px'
                        }}
                      >
                        {analytics ? analytics?.incomes : 0}
                        {
                          <>
                            {analytics?.incomesPercent && analytics?.incomesPercent.length !== 0 ? (
                              <>
                                {analytics?.incomesPercent &&
                                analytics?.incomesPercent.includes('-') ? (
                                  <>
                                    <Box
                                      sx={{
                                        borderRadius: '5px',
                                        backgroundColor: '#FFE4E1',
                                        color: '#F64D36',
                                        fontFamily: 'FixelText-Medium !important',
                                        fontWeight: 500,
                                        fontSize: {
                                          xs: '12px',
                                          sm: '16px',
                                          md: '20px'
                                        },
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: '2px 10px',
                                        maxHeight: '25px'
                                      }}
                                    >
                                      {/* <TrendingDownIcon
                                        sx={{ color: '#F64D36', fontSize: '14px', mr: 0.5 }}
                                      /> */}
                                      {`${analytics?.incomesPercent}%`}
                                    </Box>
                                  </>
                                ) : (
                                  <>
                                    <Box
                                      sx={{
                                        borderRadius: '5px',
                                        backgroundColor: '#DDF8DB',
                                        color: '#67C062',
                                        fontFamily: 'FixelText-Medium !important',
                                        fontWeight: 500,
                                        fontSize: {
                                          xs: '12px',
                                          sm: '16px',
                                          md: '20px'
                                        },
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: '2px 10px',
                                        maxHeight: '25px'
                                      }}
                                    >
                                      {' '}
                                      {/* <TrendingUpIcon
                                        sx={{ color: '#67C062', fontSize: '14px', mr: 0.5 }}
                                      /> */}
                                      +{`${analytics?.incomesPercent}%`}
                                    </Box>
                                  </>
                                )}
                              </>
                            ) : null}
                          </>
                        }
                      </Typography>
                    </Stack>
                  </Box>
                </Grid>
                <Grid item xs={6} sm={4}>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                      padding: { xs: '8px', sm: '16px', md: '24px' },
                      borderRadius: '8px',
                      backgroundColor: 'white'
                    }}
                  >
                    <Stack sx={{ width: '100%', marginLeft: '0px' }}>
                      <Typography
                        variant="subtitle"
                        sx={{
                          fontFamily: 'FixelText-Medium !important',
                          fontSize: { xs: '12px', sm: '18px', md: '24px' },
                          fontWeight: 500,
                          textAlign: 'left',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          mb: 1
                        }}
                      >
                        {`Підписників`}
                        {
                          <Typography
                            sx={{
                              fontSize: { xs: '12px', sm: '20px', md: '24px' },
                              color: '#7C7C7C'
                            }}
                          >
                            {period}
                          </Typography>
                        }
                      </Typography>

                      <Typography
                        variant="subtitle"
                        sx={{
                          fontFamily: 'FixelText-Medium !important',
                          fontSize: { xs: '12px', sm: '20px', md: '32px' },
                          fontWeight: 500,
                          textAlign: 'left',
                          cursor: 'pointer',
                          // color: '#60A5DF',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          lineHeight: '29px'
                        }}
                      >
                        {analytics ? analytics?.subscriptionNumber : 0}
                        {
                          <>
                            {analytics?.subscriptionPercent &&
                            analytics?.subscriptionPercent.length !== 0 ? (
                              <>
                                {analytics?.subscriptionPercent &&
                                analytics?.subscriptionPercent.includes('-') ? (
                                  <>
                                    <Box
                                      sx={{
                                        borderRadius: '5px',
                                        backgroundColor: '#FFE4E1',
                                        color: '#F64D36',
                                        fontFamily: 'FixelText-Medium !important',
                                        fontWeight: 500,
                                        fontSize: {
                                          xs: '12px',
                                          sm: '16px',
                                          md: '20px'
                                        },
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: '2px 10px',
                                        maxHeight: '25px'
                                      }}
                                    >
                                      {/* <TrendingDownIcon
                                        sx={{ color: '#F64D36', fontSize: '14px', mr: 0.5 }}
                                      /> */}
                                      {`${analytics?.subscriptionPercent}%`}
                                    </Box>
                                  </>
                                ) : (
                                  <>
                                    <Box
                                      sx={{
                                        borderRadius: '5px',
                                        backgroundColor: '#DDF8DB',
                                        color: '#67C062',
                                        fontFamily: 'FixelText-Medium !important',
                                        fontWeight: 500,
                                        fontSize: {
                                          xs: '12px',
                                          sm: '16px',
                                          md: '20px'
                                        },
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: '2px 10px',
                                        maxHeight: '25px'
                                      }}
                                    >
                                      {' '}
                                      {/* <TrendingUpIcon
                                        sx={{ color: '#67C062', fontSize: '14px', mr: 0.5 }}
                                      /> */}
                                      +{`${analytics?.subscriptionPercent}%`}
                                    </Box>
                                  </>
                                )}
                              </>
                            ) : null}
                          </>
                        }
                      </Typography>
                    </Stack>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      width: '100%',
                      justifyContent: 'end',
                      alignItems: 'center',
                      mb: { xs: '16px' }
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'end',
                        alignItems: 'center'
                      }}
                    >
                      <Autocomplete
                        sx={{
                          mr: { xs: '8px !important', sm: '16px !important' },
                          width: { xs: 'auto', sm: '130px' }
                        }}
                        disableClearable
                        onKeyPress={(e) => {
                          e.preventDefault();
                        }}
                        close
                        options={['Рік', 'Місяць']}
                        value={period}
                        onChange={(event, value) => {
                          setPeriod(value);
                          setYear(new Date().getFullYear());
                          if (value === 'Рік') {
                            setMonth(0);
                          } else {
                            setMonth(new Date().getMonth() + 1);
                          }
                        }}
                        renderInput={(params) => (
                          <CssTextField
                            variant="outlined"
                            sx={{ background: 'white' }}
                            {...params}
                          />
                        )}
                      />
                      {period === 'Рік' ? (
                        <DatePicker
                          value={year ? dayjs(`${year}-01-01`) : null}
                          minDate={dayjs('2023-01-01')}
                          openTo="year"
                          views={['year']}
                          slotProps={{
                            textField: {
                              variant: 'outlined',
                              inputProps: {
                                sx: {
                                  fontSize: { xs: '14px', sm: '16px' }
                                  // здесь можно адаптивно или явно
                                }
                              },
                              sx: {
                                mr: { xs: '8px !important', sm: '16px !important' },
                                width: { xs: 'auto', sm: '130px' },
                                '& label.Mui-focused': {
                                  color: '#000000'
                                },
                                '& label': {
                                  color: '#7C7C7C',
                                  opacity: 1,
                                  fontFamily: 'FixelText-Regular'
                                },
                                '& .MuiInputBase-root': {
                                  alignItems: 'center',
                                  backgroundColor: '#FFFFFF',
                                  boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                                  borderRadius: '8px'
                                  // fontSize отсюда убираем!
                                },
                                '& .MuiOutlinedInput-input': {
                                  fontSize: { xs: '14px', sm: '16px' }, // ← вот сюда
                                  fontFamily: 'FixelText-Medium !important',
                                  padding: {
                                    xs: '11px !important',
                                    sm: '15px !important'
                                  }
                                },
                                '& .MuiInputBase-input': {
                                  fontSize: { xs: '14px', sm: '16px' }, // ← вот сюда
                                  fontFamily: 'FixelText-Medium !important',
                                  padding: {
                                    xs: '11px !important',
                                    sm: '15px !important'
                                  }
                                },

                                margin: '5px 0px',

                                '& ::placeholder': {
                                  color: '#7C7C7C',
                                  opacity: 1
                                },

                                '& .MuiInputBase-root.Mui-error': {
                                  backgroundColor: '#FFE5E5 !important'
                                }
                              }
                            }
                          }}
                          onChange={(value) => {
                            if (value && value.isValid()) {
                              setYear(value.year());
                              setMonth(0);
                            }
                          }}
                        />
                      ) : null}
                      {period === 'Місяць' ? (
                        <DatePicker
                          value={dayjs().month(month - 1)}
                          openTo="month"
                          views={['month']}
                          slotProps={{
                            textField: {
                              variant: 'outlined',
                              inputProps: {
                                sx: {
                                  fontSize: { xs: '14px', sm: '16px' }, // здесь можно адаптивно или явно
                                  fontFamily: 'FixelText-Regular'
                                }
                              },
                              sx: {
                                mr: { xs: '8px !important', sm: '16px !important' },
                                width: { xs: 'auto', sm: '130px' },
                                '& label.Mui-focused': {
                                  color: '#000000'
                                },
                                '& label': {
                                  color: '#7C7C7C',
                                  opacity: 1,
                                  fontFamily: 'FixelText-Regular'
                                },
                                '& .MuiInputBase-root': {
                                  alignItems: 'center',
                                  backgroundColor: '#FFFFFF',
                                  boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                                  borderRadius: '8px'
                                  // fontSize отсюда убираем!
                                },
                                '& .MuiOutlinedInput-input': {
                                  fontSize: { xs: '14px', sm: '16px' }, // ← вот сюда
                                  fontFamily: 'FixelText-Medium !important',
                                  padding: {
                                    xs: '11px !important',
                                    sm: '15px !important'
                                  }
                                },
                                '& .MuiInputBase-input': {
                                  fontSize: { xs: '14px', sm: '16px' }, // ← вот сюда
                                  fontFamily: 'FixelText-Medium !important',
                                  padding: {
                                    xs: '11px !important',
                                    sm: '15px !important'
                                  }
                                },
                                fontFamily: 'FixelText-Medium !important',
                                margin: '5px 0px',

                                '& ::placeholder': {
                                  color: '#7C7C7C',
                                  opacity: 1
                                },

                                '& .MuiInputBase-root.Mui-error': {
                                  backgroundColor: '#FFE5E5 !important'
                                }
                              }
                            }
                          }}
                          onChange={(value, context) => {
                            setMonth(new Date(value).getMonth() + 1);
                          }}
                        />
                      ) : null}
                      {/* {period === 'День' ? (
                        <DatePicker
                          value={dayjs(day)}
                          openTo="day"
                          format="MMMM DD"
                          views={['month', 'day']}
                          sx={{ mr: 2, width: 150 }}
                          onChange={(value, context) => setDay(new Date(value).toISOString())}
                        />
                      ) : null} */}

                      <Autocomplete
                        sx={{
                          width: { xs: 'auto', sm: '300px' },
                          minWidth: { xs: '160px' }
                        }}
                        disableClearable
                        onKeyPress={(e) => {
                          e.preventDefault();
                        }}
                        options={[
                          'Товарів продано за період',
                          'Коштів отримано за період',
                          'Нових підписників за період'
                          // 'Відвідування сторінки за період'
                        ]}
                        value={sortType}
                        onChange={(event, value) => setSortType(value)}
                        renderInput={(params) => (
                          <CssTextField
                            variant="outlined"
                            sx={{ background: 'white' }}
                            {...params}
                          />
                        )}
                      />
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sx={{ mb: '20px' }}>
              <ResponsiveContainer
                width="100%"
                height={440}
                style={{
                  border: '2px solid #F0F0F0',
                  borderRadius: '5px',
                  backgroundColor: 'white'
                }}
              >
                <LineChart
                  width={500}
                  height={300}
                  data={graphData}
                  margin={{
                    top: 100,
                    right: 50,
                    left: 20,
                    bottom: 30
                  }}
                >
                  <CartesianGrid strokeDasharray="0 0" vertical={false} />
                  <XAxis
                    tickSize={15}
                    axisLine={false}
                    tickLine={false}
                    dataKey="name"
                    tick={<CustomizedAxisTick />}
                  />
                  <YAxis
                    allowDecimals={false}
                    tickSize={15}
                    axisLine={false}
                    tickLine={false}
                    dataKey="uv"
                    tick={<CustomizedAxisTick />}
                  />
                  <Tooltip
                    formatter={(value, name) => {
                      switch (sortType) {
                        case 'Товарів продано за період':
                          return [`${value} од.`, 'Продано товарів'];
                        case 'Коштів отримано за період':
                          return [`${value} грн.`, 'Коштів отримано'];
                        case 'Нових підписників за період':
                          return [value, 'Нових підписників'];
                        case 'Відвідування сторінки за період':
                          return [value, 'Відвідало сторінку'];
                        default:
                          return;
                      }
                    }}
                    labelFormatter={(label) => {
                      if (period === 'Рік') {
                        return `${label} ${year} р.`;
                      } else {
                        return `${label} ${monthHandler(month)} ${year} р.`;
                      }
                    }}
                  />

                  <Line
                    type="monotone"
                    dataKey="uv"
                    stroke="#60A5DF"
                    dot={false}
                    activeDot={{ r: 2 }}
                  />
                </LineChart>
              </ResponsiveContainer>
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="p"
                sx={{
                  margin: '20px 0px 20px',
                  wordBreak: 'break-word',
                  fontFamily: 'FixelText-Medium !important',
                  fontSize: { xs: '20px', sm: '24px' },
                  textAlign: 'left',
                  fontWeight: 500
                }}
              >
                Постійні покупці
              </Typography>
              <BuyersTable />
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="p"
                sx={{
                  margin: '20px 0px 20px',
                  wordBreak: 'break-word',
                  fontFamily: 'FixelText-Medium !important',
                  fontSize: { xs: '20px', sm: '24px' },
                  textAlign: 'left',
                  fontWeight: 500
                }}
              >
                Просування
              </Typography>
              <ServicesTable />
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="p"
                sx={{
                  margin: '20px 0px 20px',
                  wordBreak: 'break-word',
                  fontFamily: 'FixelText-Medium !important',
                  fontSize: { xs: '20px', sm: '24px' },
                  textAlign: 'left',
                  fontWeight: 500
                }}
              >
                Активні просування
              </Typography>
              <PromotionTable />
            </Grid>
          </>
        )}
        {props?.userData && props?.userData?.role === 'PREMIUM_USER' && (
          <Grid item xs={12}>
            <StyledTitle
              className="bottomBlock-title"
              style={{ marginBottom: '20px', marginTop: '0px' }}
            >
              Тарифні плани
            </StyledTitle>
          </Grid>
        )}

        <>
          {innerWidth > 820 ? (
            <Slider
              classNamae="customSlider"
              {...carouselSettings}
              style={{ width: '91%', margin: '0 auto' }}
            >
              {!props?.userData?.isWasPremium && (
                <Box sx={{ position: 'relative' }}>
                  <TariffCard
                    index="Free"
                    type="FREE_TRIAL_PREMIUM"
                    active={props?.premiumSubscription?.subscriptionType === 'FREE_TRIAL_PREMIUM'}
                  />
                </Box>
              )}
              {carouselSlides.map((slide, index) => (
                <Box key={index} sx={{ position: 'relative' }}>
                  {slide}
                </Box>
              ))}
            </Slider>
          ) : (
            <Grid container spacing={3} sx={{ justifyContent: 'center' }}>
              {!props?.userData?.isWasPremium && (
                <Grid item xs={12} sm={6} sx={{ position: 'relative' }}>
                  <TariffCard
                    index="Free"
                    type="FREE_TRIAL_PREMIUM"
                    active={props?.premiumSubscription?.subscriptionType === 'FREE_TRIAL_PREMIUM'}
                  />
                </Grid>
              )}
              {carouselSlides.map((slide, index) => (
                <Grid item xs={12} sm={6} key={index + 'slide'} sx={{ position: 'relative' }}>
                  {slide}
                </Grid>
              ))}
            </Grid>
          )}
        </>
      </Grid>
    </Page>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale,
    userData: state.global.userData,
    premiumSubscription: state.global.premiumSubscription,
    boosters: state.global.boosters
  };
};
export default connect(mapStateToProps)(TariffPage);
